const PENTHOUSE_RANK = 99;

const isPenthouseText = (value: unknown): boolean => {
  const raw = String(value ?? '').trim().toLowerCase();
  if (!raw) return false;
  return raw.includes('penthouse') || raw.includes('penthhouse') || /\bph\b/.test(raw) || raw.endsWith('ph');
};

const toBedroomRank = (bedroom: number | null | undefined, unitType: unknown): number | null => {
  if (isPenthouseText(unitType)) return PENTHOUSE_RANK;
  if (bedroom == null || !Number.isFinite(bedroom) || bedroom <= 0) return null;
  return bedroom;
};

type SuperUpgradeBedroomMatchInput = {
  blinkerBedroom: number | null | undefined;
  blinkerUnitType: unknown;
  candidateBedroom: number | null | undefined;
  candidateUnitType: unknown;
};

export const isSuperUpgradeBedroomMatch = ({
  blinkerBedroom,
  blinkerUnitType,
  candidateBedroom,
  candidateUnitType,
}: SuperUpgradeBedroomMatchInput): boolean => {
  const blinkerRank = toBedroomRank(blinkerBedroom, blinkerUnitType);
  const candidateRank = toBedroomRank(candidateBedroom, candidateUnitType);
  if (blinkerRank == null || candidateRank == null) return false;
  return candidateRank > blinkerRank;
};

